const convertIfNotUndefinedOrNull = <S, T, U extends ReadonlyArray<unknown>>(
  source: S | undefined | null,
  converter: (source: S, ...args: U) => T,
  ...args: U
): T | null => {
  let targetValue: T | null = null;
  if (source !== undefined && source !== null) {
    targetValue = converter(source, ...args);
  }

  return targetValue;
};

export default convertIfNotUndefinedOrNull;
